import * as Sentry from '@sentry/react'

type CreateSentryOptionsParameters = {
    dsn: string | undefined
    release: string | undefined
}

export function createSentryOptions({ dsn, release }: CreateSentryOptionsParameters) {
    return {
        dsn,
        release,
        integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
        tracesSampleRate: 0.5,
        tracePropagationTargets: ['localhost', /^https:\/\/monatsabschluss\.at/, /^https:\/\/test\.monatsabschluss\.at/],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
    }
}
